<div>
  <!-- 閉じるボタン -->
  <button
    id="close-btn"
    class="!tw-absolute tw-top-1 tw-right-1 !tw-flex !tw-z-10"
    mat-icon-button
    mat-dialog-close
  >
    <mat-icon>close</mat-icon>
  </button>

  <form [formGroup]="formGroup" (submit)="submit()" class="tw-p-4">
    <div mat-dialog-title class="matp-dialog-title">
      デバイス種類{{ updating ? "編集" : "新規登録" }}
    </div>

    <mat-dialog-content class="!tw-pt-2">
      <div
        class="tw-grid tw-w-11/12 tw-grid-cols-2 tw-gap-x-2 tw-gap-y-3 tw-m-auto"
      >
        <div class="tw-contents">
          <mat-form-field
            class="tw-w-full"
            appearance="outline"
            floatLabel="always"
            [ngClass]="{ 'matp-form-field-readonly': updating }"
          >
            <mat-label>デバイス種類</mat-label>
            <input
              matInput
              formControlName="deviceTypeId"
              placeholder="例）QTS110"
              id="device-type-id"
              name="deviceTypeId"
              (keyup)="samplingFrequencyFieldChange()"
              [readonly]="updating"
              required
            />
            <mat-error
              *ngIf="formGroup.controls.deviceTypeId.errors?.['required']"
            >
              デバイス種類IDを入力してください。
            </mat-error>
            <mat-error
              *ngIf="formGroup.controls.deviceTypeId.errors?.['maxlength']"
            >
              128文字以下で入力してください。
            </mat-error>
          </mat-form-field>

          <mat-form-field
            class="tw-w-full"
            appearance="outline"
            floatLabel="always"
          >
            <mat-label>表示名</mat-label>
            <input matInput formControlName="displayName" name="displayName" required />
            <mat-error *ngIf="formGroup.controls.displayName.errors?.['required']">
              表示名を入力してください。
            </mat-error>
            <mat-error *ngIf="formGroup.controls.displayName.errors?.['maxlength']">
              256文字以下で入力してください。
            </mat-error>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field
            class="tw-w-full"
            appearance="outline"
            floatLabel="always"
          >
            <mat-label>測定間隔選択肢(CSV形式) </mat-label>
            <input
              matInput
              formControlName="samplingFrequency"
              placeholder="例）5, 10, 15"
              id="collect-interval"
              name="samplingFrequency"
              [disabled]="isDisabled"
            />
            <mat-error
              *ngIf="formGroup.controls.samplingFrequency.errors?.['required']"
            >
              測定間隔を入力してください。
            </mat-error>
            <mat-error
              *ngIf="formGroup.controls.samplingFrequency.errors?.['pattern']"
            >
              CSV形式の数字で入力してください。
            </mat-error>
            <mat-error
              *ngIf="formGroup.controls.samplingFrequency.errors?.['maxlength']"
            >
              128文字以下で入力してください。
            </mat-error>
          </mat-form-field>
        </div>

        <div>
          <mat-form-field
            class="tw-w-full"
            appearance="outline"
            floatLabel="always"
          >
            <mat-label>送信間隔選択肢(CSV形式) </mat-label>
            <input
              matInput
              formControlName="reportingFrequency"
              placeholder="例）30, 45, 60, 120"
              id="transfer-interval"
              name="reportingFrequency"
              required
            />
            <mat-error
              *ngIf="formGroup.controls.reportingFrequency.errors?.['required']"
            >
              送信間隔を入力してください。
            </mat-error>
            <mat-error
              *ngIf="formGroup.controls.reportingFrequency.errors?.['pattern']"
            >
              CSV形式の数字で入力してください。
            </mat-error>
            <mat-error
              *ngIf="
                formGroup.controls.reportingFrequency.errors?.['maxlength']
              "
            >
              128文字以下で入力してください。
            </mat-error>
          </mat-form-field>
        </div>
        <div class="tw-col-span-2">
        <mat-form-field
          class="tw-w-full"
          appearance="outline"
          floatLabel="always"
        >
          <mat-label>補足/説明文</mat-label>
          <textarea
            matInput
            formControlName="description"
            placeholder=""
            id="description"
            name="description"
            rows="3"
          ></textarea>
          <mat-error
            *ngIf="formGroup.controls.description.errors?.['maxlength']"
          >
            1024文字以下で入力してください。
          </mat-error>
        </mat-form-field>
        </div>
      </div>

      <div
        class="tw-col-span-2 tw-flex tw-flex-wrap tw-justify-between tw-gap-x-4"
      >
        <mat-grid-list
          cols="2"
          rowHeight="2em"
          class="tw-min-w-[250px] tw-mt-6"
        >
          <mat-grid-tile [colspan]="2" [rowspan]="1">
            <div class="tw-mr-auto tw-m-auto">センサーリスト</div>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <div class="tw-mr-auto">温度センサー</div>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-radio-group
              color="primary"
              formControlName="temperatureSensor"
            >
              <mat-radio-button [value]="true">有</mat-radio-button>
              <mat-radio-button [value]="false">無</mat-radio-button>
            </mat-radio-group>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <div class="tw-mr-auto">気圧センサー</div>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-radio-group color="primary" formControlName="pressureSensor">
              <mat-radio-button [value]="true">有</mat-radio-button>
              <mat-radio-button [value]="false">無</mat-radio-button>
            </mat-radio-group>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <div class="tw-mr-auto">湿度センサー</div>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-radio-group color="primary" formControlName="humiditySensor">
              <mat-radio-button [value]="true">有</mat-radio-button>
              <mat-radio-button [value]="false">無</mat-radio-button>
            </mat-radio-group>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <div class="tw-mr-auto">傾斜センサー</div>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-radio-group color="primary" formControlName="tiltSensor">
              <mat-radio-button [value]="true">有</mat-radio-button>
              <mat-radio-button [value]="false">無</mat-radio-button>
            </mat-radio-group>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <div class="tw-mr-auto">照度センサー</div>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-radio-group color="primary" formControlName="lightSensor">
              <mat-radio-button [value]="true">有</mat-radio-button>
              <mat-radio-button [value]="false">無</mat-radio-button>
            </mat-radio-group>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-grid-list
          cols="2"
          rowHeight="2em"
          class="tw-min-w-[240px] tw-mt-6"
        >
          <mat-grid-tile [colspan]="2" [rowspan]="1">
            <!-- placeholder -->
            <div class="tw-mr-auto tw-m-auto">デバイス設定</div>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <div class="tw-mr-auto">位置測位</div>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-radio-group
              color="primary"
              formControlName="locationSensor"
              (change)="isLocationPrioritiesEmpty()"
            >
              <mat-radio-button [value]="true">有</mat-radio-button>
              <mat-radio-button [value]="false">無</mat-radio-button>
            </mat-radio-group>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1" class="tw-text-center">
            <div class="tw-mr-auto tw-ml-4">GNSS</div>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-radio-group
              color="primary"
              formControlName="locationTechGnss"
              (change)="isLocationPrioritiesEmpty()"
            >
              <mat-radio-button [value]="true">有</mat-radio-button>
              <mat-radio-button [value]="false">無</mat-radio-button>
            </mat-radio-group>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1" class="tw-text-center">
            <div class="tw-mr-auto tw-ml-4">Wi-Fi</div>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-radio-group
              color="primary"
              formControlName="locationTechWifi"
              (change)="isLocationPrioritiesEmpty()"
            >
              <mat-radio-button [value]="true">有</mat-radio-button>
              <mat-radio-button [value]="false">無</mat-radio-button>
            </mat-radio-group>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1" class="tw-text-center">
            <div class="tw-mr-auto tw-ml-4">Cellular</div>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-radio-group
              color="primary"
              formControlName="locationTechCellular"
              (change)="isLocationPrioritiesEmpty()"
            >
              <mat-radio-button [value]="true">有</mat-radio-button>
              <mat-radio-button [value]="false">無</mat-radio-button>
            </mat-radio-group>
          </mat-grid-tile>

          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <div class="tw-mr-auto">フライトモード</div>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-radio-group color="primary" formControlName="fmd">
              <mat-radio-button [value]="true">有</mat-radio-button>
              <mat-radio-button [value]="false">無</mat-radio-button>
            </mat-radio-group>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-grid-list
          cols="2"
          rowHeight="2em"
          class="tw-min-w-[240px] tw-mt-6"
        >
          <mat-grid-tile [colspan]="2" [rowspan]="1">
            <div class="tw-mr-auto tw-m-auto">イベント検知</div>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <div class="tw-mr-auto">落下検知</div>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-radio-group color="primary" formControlName="fallDetected">
              <mat-radio-button [value]="true">有</mat-radio-button>
              <mat-radio-button [value]="false">無</mat-radio-button>
            </mat-radio-group>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <div class="tw-mr-auto">動作検知</div>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-radio-group color="primary" formControlName="mcdDetected">
              <mat-radio-button [value]="true">有</mat-radio-button>
              <mat-radio-button [value]="false">無</mat-radio-button>
            </mat-radio-group>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <div class="tw-mr-auto">明暗検知</div>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-radio-group
              color="primary"
              formControlName="lightExposureDetected"
            >
              <mat-radio-button [value]="true">有</mat-radio-button>
              <mat-radio-button [value]="false">無</mat-radio-button>
            </mat-radio-group>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <div class="tw-mr-auto">衝撃検知</div>
          </mat-grid-tile>
          <mat-grid-tile [colspan]="1" [rowspan]="1">
            <mat-radio-group color="primary" formControlName="shockDetected">
              <mat-radio-button [value]="true">有</mat-radio-button>
              <mat-radio-button [value]="false">無</mat-radio-button>
            </mat-radio-group>
          </mat-grid-tile>
        </mat-grid-list>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions class="tw-flex !tw-justify-center !tw-px-6 tw-gap-x-4">
      <button
        id="cancel-btn"
        mat-raised-button
        mat-dialog-close
        class="tw-w-40"
      >
        <mat-icon>close</mat-icon>
        キャンセル
      </button>
      <button
        id="edit-btn"
        mat-raised-button
        color="accent"
        class="tw-w-40"
        type="submit"
        [disabled]="formGroup.invalid"
      >
        <mat-icon>done</mat-icon>
        <span>{{ updating ? "変更" : "新規登録" }}</span>
      </button>
    </mat-dialog-actions>
  </form>
</div>
